import * as React from "react";
const HighlightMessageContext = React.createContext(void 0);
export default HighlightMessageContext;
